import React from 'react';
import {NavbarDefault} from 'components/core/navbar';
import {Container} from 'components/structure/Container';
import {Content} from 'components/structure/Content';
import Table from 'components/contexts/enterprises/Table';
import Header from 'components/core/Header';
import {history} from 'constants/routes';
import urls from 'constants/urls';

const Enterprises = () => {
  return (
    <>
      <NavbarDefault active="enterprises" />
      <Content>
        <Container>
          <Header
            title="Enterprises"
            subtitle=""
            buttonText="New enterprise"
            onClick={() => {
              history.push(urls.LINKS.CREATE_ENTERPRISE);
            }}
          />
          <Table />
        </Container>
      </Content>
    </>
  );
};

export default Enterprises;
